import { useState } from "react";
import HttpClient from "../utils/HttpClient";

const MyProfileAboutModal = ({ closemodal, data, setData, updateForm, setSaveEditedData }) => {
  const [formData, setFormData] = useState(data);
  const [errors, setErrors] = useState({});
  const initDoc = {
    "docName": "",
    "pdf": ""
  }

  const validate = () => {
    let isValid = true;
    const error = {};

    if (!formData?.companyDescription) {
      error.companyDescription = "Please enter some text";
      isValid = false;
    }

    setErrors(error);
    return isValid;
  };

  const submit = () => {
    if (validate()) {
      setData({
        ...data,
        ...formData,
      });
      setSaveEditedData(true);
      closemodal();
    }
  };

  const handleInputChange = (field, value) => {
    setFormData((prevData) => ({ ...prevData, [field]: value }));
  };

  return (

    <div className="uploabannermodalbgshadow">
      <div className="compamyinfoeditbgmain">
        <h5 className="mt-2 p-0 m-3">Update</h5>
        <hr />
        <div className="crossdivicon" onClick={() => closemodal()} style={{ cursor: "pointer" }}>
          <i className="fa-solid fa-xmark"></i>
        </div>
        <div className="eidutcommhifnnfodivdibvamain">
          <div className="modal-form-container">
            <div className="compamydinfodivmain">

              <div className="compamydinfodivmainbtm">
                <p className="conattaindptxtppnewallasa">
                  About Us <span>*</span>
                </p>

                <textarea
                  rows="15"
                  type="text"
                  className="form-control"
                  placeholder="About Us"
                  name="aboutUs"
                  value={formData?.companyDescription || ""}
                  onChange={(e) =>
                    handleInputChange("companyDescription", e.target.value)
                  }
                />
                {errors.companyDescription && (
                  <span className="error">{errors.companyDescription}</span>
                )}
              </div>
            </div>
          </div>

          {/* <div className="eidutcommhifnnfodiv mt-2">
            <p><strong>Documents</strong></p>
            <div className="compamydinfodivmain">
              {formData?.doc?.map((item, i) => {
                return (<>
                  <div className="compamydinfodivmainbtm border p-2 mt-2 bg-light">
                    <p className="conattaindptxtppnewallasa">Document Name</p>
                    <input
                      type="text"
                      className="mt-1 form-control"
                      name="docName"
                      value={item?.docName}
                      onChange={(e) => handleDocumentName(e, i)}
                    />

                    <p className="conattaindptxtppnewallasa mt-2">Document File</p>
                    <input
                      key={i}
                      type="file"
                      className="mt-1 "
                      name="pdf"
                      onChange={(e) => handleDocument(e, i)}
                    />

                    <span className="float-right cursor-pointer" onClick={() => {
                      const newData = formData.doc?.filter((ele, ind) => i !== ind)
                      setFormData(prev => ({ ...prev, doc: newData }))
                    }}> <i className="fa fa-trash" /> </span>

                    {item?.pdf && (
                      <a href={item?.pdf} target="_blank" rel="noopener noreferrer" download="" className='text-primary mt-2'>
                        Open PDF <i className="fa-solid fa-download"></i>
                      </a>
                    )}
                  </div>
                </>);
              })}
            </div>
            <span onClick={handleAddMore}><i className="fa fa-plus border p-2 mt-2"></i></span>
          </div> */}

          <div className="eidutcommhifnnfodiv mt-2">
            <div className="svavtatvvbtnnmddsupscftt">
              <button
                className="svavtatvvbtnnm"
                onClick={() => {
                  submit();
                }}
              >
                Save
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};
export default MyProfileAboutModal;
